// Vendors
import React from 'react';

const Loader = () => {
  return (
    <div className="global-loading-container">
      <div className="loading loading--rotate">
        {Array.from([1, 2, 3]).map((outer) => (
          <div key={outer} className="loading__rotate-container">
            {Array.from([1, 2, 3, 4]).map((inner) => (
              <div key={inner} className="loading__ball" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Loader;
